<template lang="pug">
  div
    section.content-header
      h1 AppSuite データ連携設定

      ol.breadcrumb
        li
          router-link(:to="{name: 'admin'}")
            i.fa.fa-cog
            | システム管理
        li.active AppSuite データ連携設定

    section.content

      app-messages(:errorMessages="errors", :successMessages="successes")

      mixin returnBtn
        .pull-left
          router-link.btn.btn-default(:to="{name: 'admin'}" title="戻る"): i.fa.fa-reply

      mixin pagination
        .pull-right
          app-pagination(:is-loading="loadingPagination", :pagination="pagination", @change="getList")

      .callout.callout-info.bcard-callout
        h4 AppSuite に名刺情報を連携します。
        p
          | 連携先となるアプリケーションと抽出条件を設定し、実行ボタンをクリックしてください。
          br
          br
          | ※ 連携先となるアプリケーションは「名刺バンク２名刺マスタ」テンプレートから作成されたアプリを指定してください。
          br
          | 「名刺バンク２名刺マスタ」テンプレートはTODO: XXX で配布されています。
          br
          | ※ あらかじめ desknet's NEO 接続設定 を完了してください。
          br
          | ※ AppSuite への連携は AppSuite のご契約が必要です。

      .bcard-btnbar.clearfix
        +returnBtn

      .box.box-widget
        .box-header.with-border
          .box-title 検索条件
          .pull-right
            button.btn.btn-default.btn-xs(type="button", v-on:click="toggleIsOpen", :title="isOpen ? '閉じる' : '開く'")
              i.fa.fa-chevron-down(v-if="!isOpen")
              i.fa.fa-chevron-up(v-else)

        .box-body.collapse(:class="{in: isOpen}")
          form(@submit.prevent="getList({isInit: true})", data-testid="form-search")
            .row
              .form-group.col-sm-12
                label タグ
                sel-tags(v-model="seltags", :view_mode="false", :mode="{isDispPv: false, canAddPv: false, isEdit: false}")
                .help-block
                  p.bcard-comments.text-info ※ 選択したタグのいずれかを含むジョブを検索します。

            .bcard-btnbar.-bottom.text-right
              button.btn.btn-primary(type="submit", v-on:click="clickedSearch", data-testid="-btn-search") 検索

      template(v-if="searched")
        .bcard-btnbar.clearfix
          +pagination

        .panel.panel-default
          .panel-heading.clearfix
            router-link.btn.btn-primary(:to="{name: 'appsuite-job-add'}") ジョブの追加
            |
            |
            .btn-separator
            |
            |
            button.btn.btn-danger(type="button" @click="onClickDelButton") 削除

          loading(v-if="loading")
          template(v-else)
            //- データあり
            .table-responsive(v-if="list.length > 0")
              table.table.table-striped.table-bordered.bcard-table.table-list(:class="{'sort-mode': $store.getState('isListSortMode')}")
                thead
                  tr
                    th.bcard-table-td-chk
                      input(type="checkbox" @change="checkAll(list, $event.target.checked)" :disabled="$store.getState('isListSortMode')")
                    th.thd-jobname ジョブ名
                    th.thd-appid アプリ識別子
                    th.thd-ymdhi 処理ユーザー/日時
                    th.thd-count 成功/対象件数
                    th.thd-status 実行結果
                    th.bcard-table-th-btn
                tbody
                  tr(
                    v-for="(item, index) in list",
                    :key="item.id",
                    :class="{'selected': isChecked(item.id)}"
                  )
                    td.bcard-table-td-chk
                      input(type="checkbox", :checked="isChecked(item.id)", @change="checkItem(item.id, $event.target.checked)" :disabled="$store.getState('isListSortMode') || item.status === JOB_STATUS.RUNNING")
                    td
                      router-link(:to="{name: 'appsuite-job-edit', params: {id: '' + item.id, item: item}}", :title="item.job_name") {{item.job_name}}
                    td
                      | {{item.app_id}}
                    td
                      | {{item.execuser_full_name}}
                      br
                      | {{item.formatted_begin_time.substr(0, 16)}}
                    td.bcard-table-td-count
                      | {{item.ok_count || '0'}} / {{item.all_count || '0'}}
                    td.thd-status
                      i.fa.fa-fw(:class="statusClass(item)")
                      |
                      |
                      a(v-if="item.status === JOB_STATUS.HASERROR", @click.prevent="onClickErrorLink(item)", href="#") {{item.lang_status}}
                      span(v-else) {{item.lang_status}}
                    td.bcard-table-td-btn
                      //- いずれかのジョブが実行中
                      template(v-if="existActiveJob")
                        //- 実行中のジョブに中止ボタンを表示
                        input.btn.btn-danger(v-if="item.status === JOB_STATUS.RUNNING", type="button" value="中止" @click="cancelIntegration(item)", :class="{'disabled': doCanceling }")
                      template(v-else-if="existActiveJob === false")
                        input.btn.btn-primary(type="button", value="実行" @click="execIntegration(item)")
                      template(v-else)
                        //- なし

            //- データなし
            .panel-body.text-center(v-else) ジョブはありません。

        //-+btnbar

      .bcard-btnbar.clearfix.-bottom
        +returnBtn
        +pagination

    //------------------------------------------------------------
    //- modals
    //------------------------------------------------------------
    app-modal(type="danger" v-model="isModalConfOpen")
      template(slot="title") ジョブの削除
      h4 選択したジョブを削除します。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(type="button" @click="close(); delJobs();") 削除
        button.btn.btn-default(type="button" @click="close") キャンセル

    app-modal(type="info" v-model="isModalNoitemOpen")
      h4 削除するジョブを選択してください

    app-modal(type="primary" v-model="isExecConfModalOpen")
      template(slot="title") ジョブの実行確認
      h4 このジョブを実行します。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-primary(type="button" @click="close(); _execIntegration();") 実行
        button.btn.btn-default(type="button" @click="close") キャンセル

    app-modal(type="danger" v-model="isCancelConfModalOpen")
      template(slot="title") ジョブの中止確認
      h4 このジョブを中止します。よろしいですか？
      template(slot="footer" slot-scope="{close}")
        button.btn.btn-danger(type="button" @click="close(); _cancelIntegration();") 中止
        button.btn.btn-default(type="button" @click="close") キャンセル

    //- エラーモーダル
    modal-error-job(v-model="errorJob")

</template>

<script>
import mixinList from '@/mixins/list'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import AppPagination from '@/components/molecules/AppPagination'
import AppListSortable from '@/components/organisms/AppListSortable'
import AppListSortableNav from '@/components/organisms/AppListSortableNav'
import SelTags from '@/components/organisms/SelTags'
import Loading from '@/components/molecules/Loading'
import ModalErrorJob from './ListModalErrorJob'
import RepositoryFactory from '@/repositories/RepositoryFactory'

import { job_status } from './constants'
import { appsuite_job_status as lang_appsuite_job_status } from '@/lang/ja_JP'

const AppSuiteJobRepository = RepositoryFactory.get('appsuitejob')

export default {
  name: 'AppsuiteJobsList',
  components: { AppModal, AppMessages, AppPagination, AppListSortable, AppListSortableNav, SelTags, Loading, ModalErrorJob },
  mixins: [ mixinList ],
  data: function () {
    return {
      // 検索済みフラグ
      searched: false,
      // 検索条件開閉フラグ
      isOpen: true,
      // タグ一覧取得フラグ
      getTagList: false,

      JOB_STATUS: job_status,
      loadingPagination: true,
      loading: true,
      isModalConfOpen: false,
      isModalNoitemOpen: false,
      errorJob: {}, // エラーモーダルに表示するジョブデータ
      isExecConfModalOpen: false,

      forceCheckStatus: false, // ステータスファイルを必ずチェックするかを決めるフラグ
      existActiveJob: null, // 実行中のジョブがあるかどうか
      lastStatus: null, // 前回の連携ステータスレスポンス

      execTargetItem: null, // 実行対象ジョブ情報
      execTargetItemId: null, // 実行対象ジョブID(別の人が中止する可能性があるため、IDは別管理している)
      doCanceling: false, // キャンセル中かどうか
      isCancelConfModalOpen: false,

      // 検索条件
      seltags: []
    }
  },
  created: function () {
    // ジョブ実行監視
    this.observeJob()

    // 初期データ取得
    if (this.$route.params.init) {
      this.resetSession()

      // 検索条件を閉じる
      this.isOpen = false
      // 一覧取得
      this.getList({isInit: true})
    }

    // サイドバー以外から遷移した場合、前回の検索結果を復元する
    if (this.getSession('searched')) {
      // 前回の検索条件をセット
      // 存在しない場合、初期値をセット
      this.pagination = this.$store.getState('searchConds').pagination
      this.seltags = this.$store.getState('searchConds').conditions.seltags || ''
      // 検索条件を閉じる
      this.isOpen = false

      this.getList({isInit: false})
    }
  },
  beforeDestroy: function () {
    // interval解除
    this.$store.commit('clearIntervals')
  },
  methods: {
    /**
     * 削除ボタンを押したときに呼ばれる
     * チェックされているものがあれば削除確認モーダルを開く
     * なにもチェックされていなければ手順お知らせモーダルを開く
     */
    onClickDelButton: function () {
      if (this.hasCheckedItems()) {
        this.isModalConfOpen = true
      }
      else {
        this.isModalNoitemOpen = true
      }
    },
    /**
     * 一覧取得処理
     * @param options
     */
    getList: function (options) {
      const vm = this
      options = options || {silent: false, _noLoading: false}

      // API実行
      this.searched = true
      this.loading = !options._noLoading
      this.loadingPagination = !options.viaPagination

      let requestOptions = {}

      let params = {
        page: options.page || 1
      }

      // 検索から
      if (options.isInit) {
        let seltags_ids = []
        for (let seltag of this.seltags) {
          seltags_ids.push(seltag.id)
        }

        params.page = 1
        params.mgtags = seltags_ids

        requestOptions = {
          repo: 'appsuitejob',
          method: 'postSearch',
          params: params,
          silent: options.silent,
          onSuccess: function (response) {
            // デフォルトソート列保存
            vm.sort = 'job_name'
            vm.direction = 'asc'
            vm.saveConds()
            vm.setSession('searched', true)
          },
          finally: function () {
            vm.loading = false
            vm.loadingPagination = false
          }
        }
      }
      else {
        params.page = options.page || this.$store.getState('searchConds').conditions.page || null
        // 前回の検索条件を適用
        params.mgtags = this.$store.getState('searchConds').conditions.mgtags || null

        requestOptions = {
          repo: 'appsuitejob',
          method: 'postSearch',
          params: params,
          silent: options.silent,
          onSuccess: function (response) {
            vm.saveConds()
            vm.setSession('searched', true)
          },
          finally: function () {
            vm.loading = false
            vm.loadingPagination = false
          }
        }
      }

      this.sendListRequest(requestOptions)
    },
    /**
     * 復元したいデータを保存する
     */
    saveConds: function () {
      // 変換前のデータを追加する
      this.conditions.seltags = this.seltags

      this.$store.commit('setSearchConds', {
        target: '',
        data: {
          pagination: this.pagination,
          conditions: this.conditions
        }
      })
    },
    /**
     * [検索]ボタン押下時イベント
     */
    clickedSearch: function () {
      window.scrollTo(0, 0)
      this.toggleIsOpen()
    },
    /**
     * 検索済みフラグの切り替え
     */
    toggleIsOpen: function () {
      this.isOpen ? this.isOpen = false : this.isOpen = true
    },
    /**
     * ステータスアイコン class設定
     * @param item
     * @returns {{"fa-exclamation-triangle": boolean, "fa-check": boolean, "fa-ban": boolean, "text-red": boolean, "text-yellow": boolean}}
     */
    statusClass: function (item) {
      return {
        // アイコン
        'fa-exclamation-triangle': item.status === this.JOB_STATUS.HASERROR, // 2: エラー
        'fa-ban': item.status === this.JOB_STATUS.CANCELED, // 3: 中止
        'fa-check': item.status === this.JOB_STATUS.FINISHED, // 4: 完了
        // 色
        'text-yellow': item.status === this.JOB_STATUS.FINISHED, // 4: 完了
        'text-red': item.status === this.JOB_STATUS.HASERROR || item.status === this.JOB_STATUS.CANCELED // 2: エラー 3: 中止
      }
    },
    /**
     * エラーダイアログ表示
     * @param item
     */
    onClickErrorLink: function (item) {
      if (item.status === this.JOB_STATUS.HASERROR) {
        this.errorJob = {
          item: item,
          isOpen: true
        }
      }
    },
    /**
     * 削除処理
     */
    delJobs: function () {
      // API実行
      this.sendBulkRequest('appsuitejob', 'bulkDelete', {
        params: {
          id: this.checkedIds
        }
      })
    },
    /**
     * 連携実行
     * @param item
     */
    execIntegration: function (item) {
      this.clearMessages()
      this.isExecConfModalOpen = true
      this.execTargetItemId = item.id
      this.execTargetItem = item
    },
    /**
     * 連携実行
     */
    _execIntegration: function () {
      const vm = this

      // 対象のボタンを中止にし、それ以外を非表示にする
      vm.existActiveJob = true
      vm.forceCheckStatus = true
      vm.execTargetItem.status = vm.JOB_STATUS.RUNNING
      vm.execTargetItem.lang_status = lang_appsuite_job_status['1'] // 実行中

      // 一時的に中止ボタンを利用停止にする（直後の利用を避けるため）
      vm.doCanceling = true

      // API実行
      AppSuiteJobRepository.postExecute(this.execTargetItemId)
        // 成功時処理
        .then(function () {
          // 処理なし
          vm.forceCheckStatus = true
          vm.doCanceling = false
        })
        // システムエラー
        .catch(function (error) {
          vm.setErrorMessage(error)

          // 失敗時のステータスチェック
          AppSuiteJobRepository.getStatus()
            .then(function (response) {
              const responseData = response.data
              // 実行中判断
              vm._setExistActiveJobFlg(responseData)
            })

          // 一覧再取得
          vm.getList({page: vm.pagination.current_page || 1, silent: true, _noLoading: true})
        })
    },
    /**
     * キャンセル実行
     */
    cancelIntegration: function (item) {
      // キャンセル中は起動しない
      if (this.doCanceling) return

      this.clearMessages()
      this.execTargetItemId = item.id
      // モーダルを開く
      this.isCancelConfModalOpen = true
    },
    /**
     * キャンセル実行
     */
    _cancelIntegration: function () {
      const vm = this

      // キャンセル中フラグをON
      vm.doCanceling = true

      // API実行
      AppSuiteJobRepository.postCancel(this.execTargetItemId)
        // 成功時処理
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            // 一覧再取得
            vm.getList({page: vm.pagination.current_page || 1, silent: true, _noLoading: true})
            vm.execTargetItem = null
            vm.execTargetItemId = null
          }
        })
        // システムエラー
        .catch(function (error) {
          vm.setErrorMessage(error)
          // 一覧再取得
          vm.getList({page: vm.pagination.current_page || 1, silent: true, _noLoading: true})
          vm.doCanceling = false
        })
    },
    /**
     * ジョブ監視
     */
    observeJob: function () {
      const vm = this

      // 5秒置きにジョブステータスの確認を行う
      const getResult = setInterval(function () {
        // 前回の結果取得が終わっていない場合、結果取得を行わない
        if (vm.isReceivedResult === false) {
          return
        }

        // 結果取得フラグをオフにする
        vm.isReceivedResult = false
        AppSuiteJobRepository.getStatus()
          .then(function (response) {
            const responseData = response.data

            // 初回の場合
            if (vm.lastStatus === null) {
              // 実行中か判断
              vm._setExistActiveJobFlg(responseData)
            }
            // 2回目以降
            else {
              // 実行した直後 または 最終ステータスと異なる
              if (vm.forceCheckStatus === true || !vm._isEqualsStatus(responseData)) {
                // 一覧再取得(サイレント)
                vm.getList({page: vm.pagination.current_page || 1, silent: true, _noLoading: true})

                // 実行直後の場合、ステータス取得の内容を「実行中」で上書きする
                if (vm.forceCheckStatus === true) {
                  responseData.success = true
                  responseData.result = undefined
                  responseData.status = 'active'
                  responseData.message = undefined
                }

                // 実行した直後にはフラグを変更する必要がないため、ステータスが変わったときのみ実行する
                if (!vm._isEqualsStatus(responseData)) {
                  // 実行中か判断
                  vm._setExistActiveJobFlg(responseData)
                }
              }
            }

            // ステータスレスポンスを保存
            vm._cloneStatus(responseData)
          })
          .catch(function (error) {
            const appCode = error.response ? vm.getAppErrCode(error.response.data.data.message) : ''
            vm.existActiveJob = false
            // 未ログイン状態
            if (appCode === '4011') {
              // interval解除
              vm.$store.commit('clearIntervals')
            }
            else {
              // 一覧再読み込み
              vm.getList({page: vm.pagination.current_page || 1, silent: true, _noLoading: true})
            }
          })
          .finally(function () {
            // 結果取得フラグをオンにする
            vm.isReceivedResult = true

            // 強制チェックフラグを落とす
            vm.forceCheckStatus = false
          })
      }, this.app_interval.appSuiteJobStatus)

      // インターバルをセット（画面遷移時に自動でクリアされる）
      this.$store.commit('setIntervals', getResult)
    },
    /**
     * ステータスレスポンスをクローンする
     * @param responseData
     * @private
     */
    _cloneStatus: function (responseData) {
      let _status = {
        success: responseData.success,
        result: responseData.result,
        status: responseData.status,
        message: responseData.message
      }
      this.lastStatus = _status
    },
    /**
     * 前回と今回のステータスレスポンスが一致しているかを判断する
     * @param responseData
     * @returns {boolean}
     * @private
     */
    _isEqualsStatus: function (responseData) {
      return this.lastStatus.success === responseData.success &&
        this.lastStatus.result === responseData.result &&
        this.lastStatus.status === responseData.status &&
        this.lastStatus.message === responseData.message
    },
    /**
     * ジョブが実行中かを判断する
     * @param responseData
     * @private
     */
    _setExistActiveJobFlg: function (responseData) {
      this.existActiveJob = !!(responseData.success && responseData.status === 'active')
      if (!this.existActiveJob) {
        this.doCanceling = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .thd-jobname {
    width: 11em;

    white-space: nowrap;
  }

  .thd-appid {
    width: 8em;

    white-space: nowrap;
  }

  .thd-ymdhi {
    width: 11em;

    white-space: nowrap;
  }

  .thd-count {
    width: 8em;

    white-space: nowrap;
  }

  .thd-status {
    width: 6em;

    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/admin/appsuitejobs/List.vue